export const scrollUp = () => {
  if (!window || !document) {
    return
  }
  window.scrollTo(0, 0)
  Array.from(document.getElementsByClassName('scrollable'))?.forEach(element => { element.scrollTo(0, 0) })
}
